<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Goal Category</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Goal Category</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_Category"
                  ><i class="fa fa-plus"></i> Add Goal Category</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Goal Category</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in categories"
                      v-bind:key="item.id"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectCategory(item)"
                              data-target="#edit_activity_Category"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectCategory(item)"
                              data-target="#delete_activity_Category"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div
          id="add_termination_Category"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Goal Category</h5>
                <button
                  Category="button"
                  class="close"
                  id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label
                      >Goal Category <span class="text-danger">*</span></label
                    >
                    <input
                      v-model.trim="$v.name.$model"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.name.$error }"
                      Category="text"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      Goal Category is required
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <div
          id="edit_activity_Category"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Goal Category</h5>
                <button
                  Category="button"
                  class="close"
                  id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label
                    >Goal Category <span class="text-danger">*</span></label
                  >
                  <input
                    Category="text"
                    v-model="category.name"
                    class="form-control"
                  />
                </div>
                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    @click="onPutSubmit"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_activity_Category"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Goal Category</h3>
                  <button
                    Category="button"
                    class="close"
                    id="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="onDeleteSubmit"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        data-dismiss="modal"
                        id="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { performanceService } from "@/services/performanceService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },

  data() {
    return {
      name: "",
      category: {},
      categories: [],
      submitted: false,
      loading: false,
      error: "",
      company: authenticationService.currentOfficeValue
    };
  },

  validations: {
    name: { required }
  },

  methods: {
    selectCategory(item) {
      this.category = item;
    },

    getCategories() {
      performanceService.getGoalCategories(this.company.id).then(
        model => {
          this.categories = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      //console.log(this.name)
      performanceService.addGoalCategory(this.company.id, 0, this.name).then(
        id => {
          performanceService.getGoalCategories(this.company.id).then(r => {
            this.categories = r;
            console.log(r);
            $("#close").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPutSubmit() {
      console.log(this.expenseType);
      this.loading = true;
      performanceService
        .updateGoalCategory(
          this.category.id,
          this.category.companyId,
          this.category.status,
          this.category.name
        )
        .then(
          id => {
            performanceService.getGoalCategories(this.company.id).then(r => {
              this.categories = r;
              $("#closeEdit").click();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    onDeleteSubmit() {
      console.log(this.category);
      this.loading = true;
      performanceService.removeGoalCategory(this.category.id).then(
        id => {
          performanceService.getGoalCategories(this.company.id).then(r => {
            this.categories = r;
            $("#closeDelete").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getCategories();
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.Category === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "activityCategory"
};
</script>



// WEBPACK FOOTER //
// src/components/settings/performance/activityCategory.vue